import PlusIcon from "../../../icons/PlusIcon";
import FormModal from "../../../Modal/modals/FormModal";

export default function IngenRegistreringer<U, V = U>({
  className,
  text,
  editConfig,
  invalidateData,
}: {
  editConfig?: FormConfig<U, V>;
  invalidateData?: InvalidateDataFunction<any>;
  className?: string;
  text?: string;
}) {
  //tidligere "readOnly"
  if (!editConfig?.post) {
    return (
      <div
        className={`d-flex gap-2 justify-content-between align-items-center border rounded p-3 dashed ${
          className ?? ""
        }`}
      >
        <i className="text-muted ps-2 fw-medium">
          {text ? text : "Ingen registreringer"}
        </i>
      </div>
    );
  }
  return (
    <div
      className={`d-flex gap-2 justify-content-between align-items-center border rounded p-2 dashed ${
        className ?? ""
      }`}
    >
      <i className="text-muted ps-2 fw-medium">
        {text ? text : "Ingen registreringer"}
      </i>
      <FormModal
        editConfig={editConfig}
        invalidateData={invalidateData}
        method={"post"}
        triggerProps={{
          transparent: true,
          color: "primary",
          title: "Tilføj",
          className: "has-icon px-2 justify-content-end",
          children: (
            <>
              Tilføj
              <span className="icon-bg">
                <PlusIcon />
              </span>
            </>
          ),
        }}
      />
    </div>
  );
}
